export default __webpack_public_path__ + "static/media/about.11a5802d.jpg";